import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    .options-selector {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 4em;
    }

    .spinner-wrapper {
        position: relative;
        border-bottom: 0.1em solid #f1f1f1;
        height: 300px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 1em;
    }

    @media all and (max-width: ${variables.mobileL}) {
        .options-selector {
            flex-wrap: wrap;

            > * {
                width: 100%;
                margin-bottom: .5em;
            }
        }

        .public-page-location-section-hero {
            visibility: hidden;
            max-height: 70px;
        }
    }
    @media all and (max-width: ${variables.mobileXS}) {
        .options-selector {
            padding-top: 3em;
        }
    }
`;
